<template>
  <div class="errors-wrap">
    <back-button v-if="loading === false && total === 0" :tag="false" />
    <empty v-if="loading === false && total === 0" />
    <template v-else-if="total > 0">
      <transition
        :enter-active-class="
          [
            'animate__animated',
            swipeRight
              ? 'animate__rotateInDownRight'
              : 'animate__rotateInDownLeft',
          ].join(' ')
        "
        :leave-active-class="
          [
            'animate__animated',
            swipeRight
              ? 'animate__rotateOutUpLeft'
              : 'animate__rotateOutUpRight',
          ].join(' ')
        "
        @before-leave="beforeLeave"
      >
        <question
          :key="index"
          :data="type == 1 ? list[0] : list[index]"
          :index="index"
          :total="total"
          :type="type"
          :tag.sync="deleteTag"
          v-hammer:swipe.left.right="onSwipe"
        />
      </transition>

      <div class="btns">
        <!-- 第一题 -->
        <template v-if="index === 0">
          <van-row type="flex">
            <van-col v-if="index != last" span="24">
              <!-- <van-button type="primary" @click="next">下一题</van-button> -->
              <div class="btn-outer" @click="next">
                <div class="btn-inner">下一题</div>
              </div>
            </van-col>
            <van-col span="24">
              <!-- <van-button type="warning" @click="goBack">返回</van-button> -->
              <div class="btn-outer" @click="goBack">
                <div class="btn-inner">返回</div>
              </div>
            </van-col>
          </van-row>
        </template>
        <!-- 最后一题 -->
        <template v-else-if="index === last">
          <van-row type="flex">
            <van-col span="24">
              <!-- <van-button type="danger" @click="prev">上一题</van-button> -->
              <div class="btn-outer" @click="prev">
                <div class="btn-inner">上一题</div>
              </div>
            </van-col>
            <van-col span="24">
              <!-- <van-button type="warning" @click="goBack">返回</van-button> -->
              <div class="btn-outer" @click="goBack">
                <div class="btn-inner">返回</div>
              </div>
            </van-col>
          </van-row>
        </template>
        <!-- 中间 -->
        <template v-else>
          <van-row type="flex" gutter="20">
            <van-col span="12">
              <!-- <van-button type="danger" @click="prev">上一题</van-button> -->
              <div class="btn-outer" @click="prev">
                <div class="btn-inner">上一题</div>
              </div>
            </van-col>
            <van-col span="12">
              <!-- <van-button type="primary" @click="next">下一题</van-button> -->
              <div class="btn-outer" @click="next">
                <div class="btn-inner">下一题</div>
              </div>
            </van-col>
            <van-col span="24">
              <!-- <van-button type="warning" @click="goBack">返回</van-button> -->
              <div class="btn-outer" @click="goBack">
                <div class="btn-inner">返回</div>
              </div>
            </van-col>
          </van-row>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
import Empty from "./Empty";
import Question from "./Question";
import BackButton from "@/components/BackButton.vue";
export default {
  components: {
    Empty,
    Question,
    BackButton,
  },
  data() {
    return {
      loading: false,
      index: 0,
      list: [],
      swipeRight: true,
      total: 0,
      answerMap: ["A", "B", "C", "D"],
      deleteTag: false,
    };
  },
  computed: {
    last: function () {
      return this.total - 1;
    },
    type() {
      return Number(this.$route.query.type);
    },
    score() {
      return Number(this.$route.query.score);
    },
    duration() {
      return this.$route.query.duration;
    },
  },
  methods: {
    beforeLeave(el) {
      el.classList.add("before-leave");
      document.getElementById("app").scrollTop = 0;
    },
    async getList() {
      try {
        this.$toast.loading({
          message: "获取错题中...",
          forbidClick: true,
        });
        this.loading = true;
        if (this.type === 1) {
          const res = await this.$axios.post(`/Question/errorList`, {
            page: this.index + 1,
            size: 1,
          });
          this.list = (res?.data.list ?? []).map((item) => {
            item.isView = false;
            item.degree = Number(item.star);
            return item;
          });
          this.total = Number(res?.data.total ?? 0);
        } else if (this.type === 2 || this.type == 3) {
          const res = await this.$axios.post(`/Question/questionAnaly`);
          this.list = (res?.data ?? []).map((item) => {
            item.solution = this.answerMap.indexOf(item.correct);
            item.choosen = this.answerMap.indexOf(item.reply);
            item.degree = Number(item.star);
            item.isView = true;
            return item;
          });
          this.total = Number(this.list.length ?? 0);
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.msg || "获取题目发生错误",
          duration: 2000,
        });
        console.log(error);
      } finally {
        this.loading = false;
        this.$toast.clear();
      }
    },
    onSwipe(event) {
      console.log(event);
      if (event.type == "swipeleft") {
        this.next();
      } else if (event.type == "swiperight") {
        this.prev();
      }
    },
    // 上一题
    prev() {
      if (this.index <= 0) {
        this.index = 0;
        return;
      }
      this.swipeRight = false;
      this.index--;
      if (this.type === 1) {
        this.getList();
      }
    },
    // 下一题
    next() {
      if (this.index >= this.last) {
        this.index = this.last;
        return;
      }
      this.swipeRight = true;
      if (this.deleteTag) {
        this.deleteTag = false;
      } else {
        this.index++;
      }
      if (this.type === 1) {
        this.getList();
      }
    },
    goBack() {
      if (this.type === 2) {
        this.$router.replace(
          `/question/result?type=2&score=${this.score}&duration=${this.duration}`
        );
      } else if (this.type == 3) {
        this.$router.replace(`/versus/result?type=2`);
      } else {
        this.$router.replace("/print");
      }
    },
  },
  created() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.errors-wrap {
  @include content-bg;

  padding: 50px 20px 20px 20px;
  @include safe-area-bottom("20px");

  .before-leave {
    position: absolute;
    right: 20px;
    left: 20px;
  }

  .btns {
    margin-top: 15px;

    .van-col--24:last-child {
      margin-top: 15px;
    }

    // .van-button {
    //   width: 100%;
    //   height: 40px;
    //   font-size: 17px;
    //   font-weight: bold;
    //   vertical-align: middle;
    //   border: none;
    //   border-radius: 20px;

    //   &.van-button--primary {
    //     position: relative;
    //     background-color: $button-blue-color;

    //     &::before {
    //       position: absolute;
    //       top: 0;
    //       z-index: 100;
    //       width: 100%;
    //       height: 100%;
    //       // background: #F2F7ED;
    //       background: red;
    //       border: 1px solid #000;
    //       border-radius: 16px;
    //     }
    //   }

    //   &.van-button--warning {
    //     background-color: $button-green-color;
    //   }
    //   &.van-button--danger {
    //     background-color: $button-orange-color;
    //   }
    // }
  }
}
</style>
